/**
 * Adds a MutationObserver to hostElements to be able to react to slot content changes.
 * This is especially helpful for complex component structures which need to be reinitialized if the slot content changes.
 * @param callback Callback function that is called when mutionobserver detects a change
 * @param hostElement The element to which the mutionobserver will be attached
 * @param config Optional options for the observer (which mutations to observe) https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver
 */
export function detectSlotChanges(callback: () => void, hostElement: any, config?: any): void {
  const slotObserver = (mutationsList) => {
    for (const {} of mutationsList) {
      callback();
    }
  };
  const observer = new MutationObserver(slotObserver);
  if (config) {
    observer.observe(hostElement, { ...config });
    observer.observe(hostElement.shadowRoot, { ...config });
  } else {
    observer.observe(hostElement, { childList: true });
    observer.observe(hostElement.shadowRoot, { childList: true });
  }
}

export function detectMarkupChanges(callback: () => void, hostElement: any): void {
  const slotObserver = (mutationsList) => {
    for (const mutation of mutationsList) {
      if (
        mutation.type === "subtree" ||
        mutation.type === "characterData" ||
        mutation.type === "attributes" ||
        mutation.type === "childList"
      ) {
        callback();
      }
    }
  };
  const observer = new MutationObserver(slotObserver);
  observer.observe(hostElement, { subtree: true, childList: true, characterData: true, attributes: true });
  observer.observe(hostElement.shadowRoot, { subtree: true, childList: true, characterData: true, attributes: true });
}
